var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.122565 0.716166C-0.502027 2.41875 1.36818 7.54675 3.294 10.3667C5.37598 13.5058 7.9264 15.4744 11.7781 16.9642C16.7227 18.9328 18.2322 18.1879 17.9719 13.9314C17.8158 11.3776 17.8158 11.3776 15.5777 10.8987C13.808 10.5263 13.1834 10.5795 12.4026 11.3244C11.2055 12.4417 10.3207 12.0692 7.66615 9.30254C5.89647 7.38713 5.89647 7.38713 6.78131 5.84417C7.45795 4.67364 7.56205 3.82235 7.24976 2.22617C7.24976 2.22617 7.16484 1.43887 6.74844 0.612669C6.45536 0.0311337 6.31287 0.151144 3.86655 0.044733C1.42023 -0.0616798 0.434862 -0.0287151 0.122565 0.716166ZM6.15672 2.70502C6.41697 3.76914 6.26082 4.3544 5.53213 5.04608C5.01163 5.52493 4.54319 6.21661 4.54319 6.58905C4.54319 7.75957 7.56205 11.484 9.48788 12.7077L11.3617 13.8782L12.5067 12.7609C13.4436 11.9096 14.0162 11.75 15.2133 12.1224C16.6186 12.4949 16.7748 12.7609 16.7748 14.6231C16.7748 16.6449 16.7227 16.6981 15.0051 16.5385C8.96739 16.0597 2.66941 9.72819 1.62842 3.13067C1.62842 3.13067 0.845993 1.10885 1.62842 1.10885C2.34566 1.10885 3.5022 1.10885 3.5022 1.10885C5.48008 1.26847 5.84442 1.48129 6.15672 2.70502Z",
    fill: "#506991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contactInfo.1e27863207e47bc697ad256472a89c57.svg";
export { ForwardRef as ReactComponent };